import Cookies from 'js-cookie';
import sha256 from 'sha256';
import { type BaseUser } from 'Users';

// Phone is stored as E.164 (e.g. "+12163714694"). Different ad platforms expect different
// formats before SHA-256, so we emit both:
//   - sha256_phone_number: E.164 as-is, with the "+". Google Ads Enhanced Conversions format.
//     https://support.google.com/google-ads/answer/13258081
//   - sha256_phone_number_digits_only: country code + digits, no "+". Meta CAPI format.
//     https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters/
// The same hash must come out of the browser Pixel/tag and the server-side CAPI for user
// matching to dedup, so the server job mirrors the digits-only recipe.
export default async function getUserAnalyticsData(user: BaseUser) {
    const phoneDigitsOnly = user.phone?.replace('+', '');
    const [emailHash, phoneHash, phoneDigitsOnlyHash] = await Promise.all([
        user.email ? sha256(user.email) : undefined,
        user.phone ? sha256(user.phone) : undefined,
        phoneDigitsOnly ? sha256(phoneDigitsOnly) : undefined,
    ]);
    return {
        user_id: user.id,
        sha256_email_address: emailHash,
        sha256_phone_number: phoneHash,
        sha256_phone_number_digits_only: phoneDigitsOnlyHash,
        country: window.cloudflareCountryCode,
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc') || Cookies.get('scraped_fbc'),
        li_fat_id: Cookies.get('li_fat_id') || Cookies.get('scraped_li_fat_id'),
    };
}
